import { render } from "./AppRichiesteAtleti.vue?vue&type=template&id=09203f47&scoped=true"
import script from "./AppRichiesteAtleti.vue?vue&type=script&lang=js"
export * from "./AppRichiesteAtleti.vue?vue&type=script&lang=js"

import "./AppRichiesteAtleti.vue?vue&type=style&index=0&id=09203f47&scoped=true&lang=css"

import exportComponent from "/var/www/html/levante_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09203f47"]])

export default __exports__